<template>
    <div class="progress-bar-wrapper">
        <div :style="{ width: (answeredQuestions.length / state.length) * 100 + '%' }" class="progress-bar" />
    </div>
</template>

<script setup>
import { WIZARD_STATE_KEY_NAME } from '@/consts/localStorage';
import { computed, onBeforeMount, ref } from 'vue';
import { LocalStorageService } from '../services/LocalStorageService.js';

const localStorageService = new LocalStorageService();

const state = ref(localStorageService.getState());

onBeforeMount(() => {
    window.addEventListener(`${WIZARD_STATE_KEY_NAME}-localstorage-changed`, event => {
        state.value = event.detail.storage;
    });
});

const answeredQuestions = computed(() =>
    state.value.filter(question => localStorageService.questionAnswered(question))
);
</script>

<style lang="scss">
@import '../assets/scss/variables.scss';

.progress-bar-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    height: 5px;

    .progress-bar {
        height: 100%;
        background-color: $tetriary-color;
        transition: 1s;
    }
}
</style>
